import React from 'react';
import { motion } from 'framer-motion';
import { XCircle, CheckCircle2 } from 'lucide-react';
export function Agitation() {
  return <section className="py-20 md:py-32 bg-zinc-950 border-y border-zinc-800" data-id="element-18">
      <div className="max-w-6xl mx-auto px-4 md:px-6" data-id="element-19">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="max-w-3xl mx-auto text-center mb-16" data-id="element-20">
          <h2 className="text-3xl md:text-4xl font-bold text-white tracking-tight mb-6" data-id="element-21">
            No necesitás más mensajes. Necesitás mejores conversaciones.
          </h2>
          <p className="text-lg text-zinc-400 text-balance" data-id="element-22">
            En una tienda de iPhones, llenar el inbox no sirve si las personas
            que llegan no tienen intención real, presupuesto o un equipo para
            entregar como parte de pago. La publicidad tiene que filtrar antes
            de que el cliente escriba.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto" data-id="element-23">
          {/* Generic Campaigns */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-zinc-900 border border-red-900/30 rounded-3xl p-8 relative overflow-hidden" data-id="element-24">
            <div className="absolute top-0 left-0 w-full h-1 bg-red-500/50" data-id="element-25"></div>
            <h3 className="text-xl font-bold text-white mb-6 flex items-center gap-2" data-id="element-26">
              <span className="w-8 h-8 rounded-full bg-red-500/10 flex items-center justify-center" data-id="element-27">
                <XCircle className="w-5 h-5 text-red-500" data-id="element-28" />
              </span>
              Campañas genéricas
            </h3>
            <ul className="space-y-4" data-id="element-29">
              {['Muchos mensajes', 'Baja intención', 'Preguntas vacías', 'Pérdida de tiempo', 'Poca claridad'].map((item, i) => <li key={i} className="flex items-start gap-3 text-zinc-400" data-id="element-30">
                  <XCircle className="w-5 h-5 text-red-500/50 shrink-0 mt-0.5" data-id="element-31" />
                  <span data-id="element-32">{item}</span>
                </li>)}
            </ul>
          </motion.div>

          {/* System Campaigns */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-zinc-900 border border-blue-500/30 rounded-3xl p-8 relative overflow-hidden shadow-[0_0_30px_rgba(37,99,235,0.1)]" data-id="element-33">
            <div className="absolute top-0 left-0 w-full h-1 bg-blue-500" data-id="element-34"></div>
            <h3 className="text-xl font-bold text-white mb-6 flex items-center gap-2" data-id="element-35">
              <span className="w-8 h-8 rounded-full bg-blue-500/10 flex items-center justify-center" data-id="element-36">
                <CheckCircle2 className="w-5 h-5 text-blue-500" data-id="element-37" />
              </span>
              Sistema iPhone Ads
            </h3>
            <ul className="space-y-4" data-id="element-38">
              {['Anuncios por modelo', 'Oferta clara', 'Plan canje como filtro', 'Conversaciones más calificadas', 'Mejor análisis comercial'].map((item, i) => <li key={i} className="flex items-start gap-3 text-zinc-200 font-medium" data-id="element-39">
                  <CheckCircle2 className="w-5 h-5 text-green-500 shrink-0 mt-0.5" data-id="element-40" />
                  <span data-id="element-41">{item}</span>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}